// VFX: Anamorphic Lens Streak
// Category: overlays  ·  Tags: cinematic, lens, anamorphic, flare, streak
// Horizontal blue-tinted anamorphic streak — cinema prime lens simulation.
import {
  AbsoluteFill,
  useCurrentFrame,
  useVideoConfig,
  interpolate,
} from "remotion";
import React from "react";

export default function FxAnamorphicStreakHorizontal800Ms() {
  const frame = useCurrentFrame();
  const { durationInFrames, width } = useVideoConfig();
  const half = durationInFrames / 2;
  const intensity = interpolate(
    frame,
    [0, half, durationInFrames],
    [0, 1, 0],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
  );
  const xShift = interpolate(
    frame,
    [0, durationInFrames],
    [-0.1, 0.15],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
  );
  return (
    <AbsoluteFill style={{ background: "#0a0e1a" }}>
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(ellipse 30% 30% at 60% 45%, rgba(255,255,255,0.18) 0%, transparent 70%)",
          opacity: intensity,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "45%",
          left: `${xShift * 100}%`,
          width: "150%",
          height: 6,
          background:
            "linear-gradient(90deg, transparent 0%, rgba(110,200,255,0.0) 15%, rgba(110,200,255,0.95) 45%, rgba(180,230,255,1) 50%, rgba(110,200,255,0.95) 55%, rgba(110,200,255,0.0) 85%, transparent 100%)",
          filter: "blur(2px)",
          opacity: intensity,
          transform: "translateY(-50%)",
          boxShadow:
            "0 0 30px rgba(110,200,255,0.8), 0 0 80px rgba(110,200,255,0.4)",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "45%",
          left: `${xShift * 100}%`,
          width: "150%",
          height: 1,
          background: "#ffffff",
          opacity: intensity * 0.9,
          transform: "translateY(-50%)",
        }}
      />
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
